import { v4 as uuidv4 } from 'uuid';
import _size from 'lodash/size';

export const createStackActions = (set, get) => ({
  addStack: (designId, stackData, anchorSide) => {
    const stackId = uuidv4();
    set((state) => {
      const design = state.designs?.[designId];
      if (!design) return state;

      return {
        designs: {
          ...state.designs,
          [designId]: {
            ...design,
            AnchorSide: anchorSide || state.designs[designId].AnchorSide,
            Stacks: [
              ...design.Stacks,
              {
                ...stackData[0],
                StackId: stackId
              }
            ]
          }
        }
      };
    });
    return stackId;
  },

  updateStack: (designId, stackId, stackData) => {
    set((state) => {
      const design = state.designs[designId];
      if (!design) return state;

      return {
        designs: {
          ...state.designs,
          [designId]: {
            ...design,
            Stacks: design.Stacks.map((stack) => (stack.StackId === stackId
              ? { ...stack, ...stackData }
              : stack)
            )
          }
        }
      };
    });
  },

  removeStack: (designId, stackId) => {
    set((state) => {
      const design = state.designs[designId];
      if (!design) return state;

      return {
        designs: {
          ...state.designs,
          [designId]: {
            ...design,
            Stacks: design.Stacks.filter((stack) => stack.StackId !== stackId)
          }
        }
      };
    });
  }
});
